import { render } from "./TourBookingDashboard.vue?vue&type=template&id=5dace845"
import script from "./TourBookingDashboard.vue?vue&type=script&lang=js"
export * from "./TourBookingDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__